export const templates = {
  'page-home': './Templates/Homepage',
  'page-work': './Templates/Work',
  'page-expertise': './Templates/Expertise',
  'single-project': './Templates/Project',
  'page-contact': './Templates/ContactUs',
  'page-404': './Templates/Page404'
}



// WEBPACK FOOTER //
// ./src/components/Page/Templates/index.js